import arrowLeft from "../../../assets/images/leftArrowPrimary.svg";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    closeModal: () => void;
}

export default function CompareModalGoback({ closeModal }: Props) {
    const { t } = useTranslation();
    return (
        <div onClick={closeModal} className="flex gap-x-3 items-center text-md text-primary mb-5 cursor-pointer">
            <img src={arrowLeft} className="h-3 w-3" alt="Back" />
            {t("comparePage.goBack")}
        </div>
    );
}
